<div class="sample-prompt-container" [formGroup]="promptForm">
    <epd-select
        #dropdownComponent
        placeholder="Sample Prompts"
        formControlName="prompt"
        [allowClear]="false"
        title="Start your search with the prompt"
    >
        <ng-container *ngFor="let group of samplePromptGroups">
            <epd-option
                [value]="group.header"
                [label]="group.header"
                [disabled]="true"
                class="prompt-section-header"
            ></epd-option>
            <epd-option *ngFor="let prompt of group.prompts" [value]="prompt" [label]="prompt"></epd-option>
        </ng-container>
    </epd-select>
</div>
